<div class="funnel-entry" [ngClass]="{ 'funnel-entry--large': size === 'large', 'funnel-entry--small': size === 'small', 'funnel-entry--compact': size === 'compact' }">
    <div [ngClass]="{ 'well well--white well--bordered': size !== 'compact' && size !== 'clean' }">
        <ng-content></ng-content>
    </div>
</div>
